module.exports = __webpack_public_path__ + "img/danger.72277f22.svg";